
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import {
  FaLaptopCode, FaMobileAlt, FaShoppingCart, FaDatabase, FaGlobe,
  FaGraduationCap, FaServer, FaEnvelope, FaChartLine, FaPaintBrush,
  FaCog, FaHeadset, FaProjectDiagram
} from 'react-icons/fa';
import '../Assets/Css/HasplITServices.css';
import '../Assets/Css/services.css';
import '../Assets/Css/home.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';

const agriServices = [
  { icon: <FaLaptopCode />, text: "Agriculture Web Design & Development" },
  { icon: <FaDatabase />, text: "Seeds Management & Agri ERP Software" },
  { icon: <FaMobileAlt />, text: "Mobile App Development for Agri Startups" },
  { icon: <FaShoppingCart />, text: "Agri E-commerce and Marketplace Solutions" },
  { icon: <FaGlobe />, text: "Online Directories & Agri Community Platforms" },
  { icon: <FaGraduationCap />, text: "E-learning Portals for Agri Education" },
  { icon: <FaServer />, text: "Hosting, Domains & Email Setup for Agri Brands" },
  { icon: <FaChartLine />, text: "SEO & Digital Marketing for Agri Products/Services" },
];

const businessServices = [
  { icon: <FaGlobe />, text: "Website Design & Development (Static, Dynamic, WordPress, E-commerce)" },
  { icon: <FaDatabase />, text: "Custom Web Applications & CRM Development" },
  { icon: <FaMobileAlt />, text: "Android/iOS Mobile App Development" },
  { icon: <FaCog />, text: "Software Solutions for Inventory, Billing, and CRM" },
  { icon: <FaPaintBrush />, text: "Graphic Design (Logos, Brochures, Social Media Creatives)" },
  { icon: <FaChartLine />, text: "SEO, PPC, and Complete Digital Marketing Services" },
  { icon: <FaServer />, text: "Cloud Hosting & Server Management" },
  { icon: <FaEnvelope />, text: "Business Email Setup (Gmail, Zoho, Outlook integration)" },
  { icon: <FaProjectDiagram />, text: "IT Consultation & Project Management" },
  { icon: <FaHeadset />, text: "24/7 Tech Support & Maintenance Services" },
];

const HasplITServices = () => {
   const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
    AOS.refresh();
  }, []);

  const renderServiceCards = (services) => (
    <Row className="g-4">
      {services.map((service, index) => (
        <Col key={index} xs={12} sm={6} md={4} lg={3} data-aos="fade-up">
          <Card className="it-service-card text-center shadow h-100">
            <Card.Body>
              <div className="mb-3" style={{ fontSize: '2rem', color: '#2e7d32' }}>
                {service.icon}
              </div>
              <Card.Text className="small fw-semibold text-muted">
                {service.text}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );

  return (
    <div style={{ minHeight: '100vh' }}>
      <div className="bannerefacilties-section d-flex align-items-center justify-content-center">
        <div className="bannerefacilties-overlay text-center" data-aos="zoom-in">
          <h2 className="banner1-title">HASPL IT & Digital Services</h2>
          <p className="banner1-subtitle" style={{ maxWidth: '700px' }} data-aos="zoom-in" data-aos-delay="200">
            Powering progress through smart IT solutions — from digital labs to training hubs, we enable innovation across agri-tech and rural industries.
          </p>
        </div>
      </div>

      <section className="py-5 bg-white">
        <Container>
          <Row className="text-center mb-5" data-aos="fade-down">
            <Col>
              <h3 className="fw-bold section-title">
                HASPL <span style={{ color: '#16343E' }}>IT & Digital Services</span>
              </h3>
              <p className="text-muted mx-auto mt-2" style={{ maxWidth: '720px' }}>
                Smart IT Solutions for Agriculture & All Business Sectors.
              </p>
            </Col>
          </Row>

          <h5 className="fw-bold mb-3" style={{ color: '#2e7d32' }}> For Agri Businesses:</h5>
          {renderServiceCards(agriServices)}

          <hr className="my-5" />

          <h5 className="fw-bold mb-3" style={{ color: '#0d47a1' }}> For All Other Businesses:</h5>
          {renderServiceCards(businessServices)}
        </Container>
      </section>

<section className="py-5 bg-white">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <h4 className="fw-bold mb-3">Want to know more?</h4>
              <p className="text-muted mb-4">
                For more information, please contact us or fill the form attached herewith.
              </p>
              <button
                className="btn btn-success px-4 py-2 rounded-pill"
                onClick={() => navigate('/contact')}
              >
                Contact Us
              </button>
            </Col>
          </Row>
        </Container>
      </section>

    </div>
  );
};

export default HasplITServices;